import type { ComponentProps, FC, ReactNode } from 'react';

import { ActionContainerClassName, Container, Text } from './styled';

import { Button, ButtonVariant } from '../Button';
import type { IconName } from '../Icon';

type IBottomToastProps = ComponentProps<typeof Container> & {
    text: string;
    buttonText?: string;
    buttonIcon?: IconName;
    onClick?: () => void;
    actions?: ReactNode[];
};

export const BottomToast: FC<IBottomToastProps> = ({
    text,
    onClick,
    buttonIcon,
    buttonText,
    actions,
    ...props
}) => {
    return (
        <Container {...props}>
            <Text>{text}</Text>
            {buttonText && (
                <Button
                    variant={ButtonVariant.PRIMARY}
                    onClick={onClick}
                    iconName={buttonIcon}
                >
                    {buttonText}
                </Button>
            )}
            {actions && (
                <ActionContainerClassName>{actions}</ActionContainerClassName>
            )}
        </Container>
    );
};

BottomToast.defaultProps = {
    buttonText: '',
    onClick: undefined,
    buttonIcon: undefined,
    actions: [],
};
